import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {  ListTableComponent  } from '@ppl/ui';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { SectionsService } from '../../../../services/sections.service';
import { ClaimsService } from '../../../../services/claims.service';
import { UserService } from '../../../../services/user.service';
import { StorageService } from '../../../../services/storage.service';

@Component({
  selector: 'ppl-billable-provider-rates-list',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './billable-provider-rates-list.component.html',
  styleUrl: './billable-provider-rates-list.component.css',
})
export class BillableProviderRatesListComponent {
  sharedDataKey: string = STATIC_DATA.SHARED_PARTICIPANT_PROVIDER_RATES_DATA;
  pageId: string = PAGE_CONSTANTS.BILLABLE_PROVIDER_RATES_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isReadOnly = false;
  isPageRestrictionLoaded = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router,
    private sharedDataService: SharedDataService,
    private sectionService: SectionsService, private claimsService: ClaimsService, private userService: UserService,
    private storageService: StorageService,
    private allowListStore: AllowListAuthStore
  ) {
  }

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.storageService.setPaBillRateId(null);
    this.setPageAccess();
  }
  onAddParticipantProviderRates() {
    this.router.navigate(['/home/addBillablePersonalAssistantRates','add']);
  }

  rowClicked(rowDetail: any) {
    this.userService.setLeadEntry('associationRates');
    this.sectionService.setFlow('associationRates');
    this.storageService.setPaBillRateId(rowDetail.paBillRateId);
      this.claimsService.getBillableProviderRates(
          this.programName,
          rowDetail.paBillRateId,
          false
        )
        .subscribe((data: any) => {
          this.claimsService.setFormData('association_rates', data.responsedata);
          setTimeout(() => {
            this.router.navigate(['/home/addBillablePersonalAssistantRates', 'update']);
          }, 200);
        });
  }


  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }
}
